import { render, staticRenderFns } from "./PersonasTabFichajes.vue?vue&type=template&id=4c044756&"
import script from "./PersonasTabFichajes.vue?vue&type=script&lang=js&"
export * from "./PersonasTabFichajes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports